import React from 'react';
import PropTypes from 'prop-types';
import { FilePicker } from '@bingads-webui/file-picker';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import UploadService from '@bingads-webui-component-legacy/azure-upload/index';
import { iframeDownload } from '@bingads-webui/download-service';
import { getBlobUploadUrl, postPreviewTask, pollExecutionResult } from './api';

class UploadInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isUploadEnabled: false,
      progressPercentage: 0,
      progressMaxPercentage: 0.1,
    };
    this.timer = null;
    this.filePicker = null;
    this.filePickerRef = React.createRef();
  }

  componentDidMount() {
    const { i18n } = this.props;
    this.filePicker = new FilePicker({
      theme: 'default',
      allowedFileExtensions: ['.csv', '.zip'],
      i18n,
      validator: () => {
        this.setState({ isUploadEnabled: true });
        this.clearError();
      },
      displayFilePath: 'filename',
    }).render();
    this.filePicker.on('error.extension', () => {
      this.setState({ isUploadEnabled: false });
      this.clearError();
    });
    this.filePicker.on('cleared', () => {
      this.setState({ isUploadEnabled: false });
      this.clearError();
    });
    this.filePickerRef.current.appendChild(this.filePicker.el);
  }

  clearError() {
    this.props.onError('');
  }

  async upload() {
    const { i18n, IsProdEnv } = this.props;
    const file = this.filePicker.fileObject;
    try {
      this.props.onUploadStart();
      this.setState({ progressPercentage: 0, progressMaxPercentage: 0.1 });
      this.timer = setInterval(() => {
        const { progressPercentage, progressMaxPercentage } = this.state;
        if (progressPercentage < progressMaxPercentage) {
          this.setState({
            progressPercentage: progressPercentage + 0.002,
          });
        }
      }, 100);
      const fileNameSplitArray = file.name.split('.');
      const extension = fileNameSplitArray[fileNameSplitArray.length - 1];
      const { SasUrl, BlobName } = await getBlobUploadUrl({ extension });
      this.setState({ progressPercentage: 0.1, progressMaxPercentage: 0.2 });

      const uploadService = new UploadService({
        blobSetting: {
          SasUrl,
          blobName: BlobName,
        },
        file,
      });

      await uploadService.start();
      this.setState({ progressPercentage: 0.2, progressMaxPercentage: 0.4 });
      const previweTask = await postPreviewTask({ BlobName, fileName: file.name, IsProdEnv });
      this.setState({ progressPercentage: 0.4, progressMaxPercentage: 1 });
      const taskId = previweTask.TaskItemExecutions[0].Id;
      const previewResult = await pollExecutionResult({ id: taskId });
      this.setState({ progressPercentage: 1 });
      clearInterval(this.timer);
      this.filePicker.$el.find(`#${this.filePicker.fileInputCssId}`).val('');
      this.filePicker.removeFile();
      this.props.onUploadFinish({
        ...previewResult,
        BlobName,
        fileName: file.name,
      });
    } catch (e) {
      this.props.onError(i18n.getString(_TL_('We\'ve encountered an error. Please try again or contact support.')));
      this.setState({ progressPercentage: 1 });
      clearInterval(this.timer);
    } finally {
      this.setState({ isUploadEnabled: false });
    }
  }

  downloadSampleFile() {
    const { publicPath } = this.props;
    iframeDownload(`${publicPath}files/templates/HotelCenter/ReconciliationReportSample.csv`);
  }

  render() {
    const { isUploadEnabled, progressPercentage } = this.state;
    const { i18n, uploading } = this.props;

    return (
      <React.Fragment>
        {uploading && <ProgressIndicator
          label={i18n.getString(progressPercentage < 1 ? _TL_('Uploading...') : _TL_('Upload finished.'))}
          percentComplete={progressPercentage}
        />}
        <div className="file-picker-container" style={{ display: uploading ? 'none' : 'block' }}>
          <div className="row">
            <div className="col-md-4">
              <div className="file-picker-container" ref={this.filePickerRef} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <p>{i18n.getString(_TL_('Supported File formats: CSV, ZIP. '))}<a href="#!" onClick={() => this.downloadSampleFile()}>{i18n.getString(_TL_('Sample file'))}</a></p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <PrimaryButton className="btn-submit" text={i18n.getString(_TL_('Upload and preview'))} onClick={() => this.upload()} allowDisabledFocus disabled={!isUploadEnabled} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

UploadInput.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  IsProdEnv: PropTypes.bool.isRequired,
  publicPath: PropTypes.string.isRequired,
  uploading: PropTypes.bool.isRequired,
  onUploadStart: PropTypes.func.isRequired,
  onUploadFinish: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
export default UploadInput;
